import Debug from 'debug'
import Session from './Session.js'

const debug = Debug('cbio.sessions')

export default (api, sockets) => ({

  create: async (resource = {}, query, options) => {
    debug('create()', resource, query)
    return new Session(api, sockets, await api.create(Session.url(), resource, query, options))
  },

  get: async (idOrCode, query, options) => {
    debug('get()', idOrCode, query)
    return new Session(api, sockets, await api.fetch(Session.url({ id: idOrCode }), query, options))
  },

  list: async (query, options) => {
    debug('list()', query)
    const sessions = await api.list(Session.url(), query, options)
    return sessions.map(session => new Session(api, sockets, session))
  }

})

export { Session }
